import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Defense-in-depth hook: ensures only admin/nutricionista users can render this page.
 * The <AdminRoute> wrapper in App.js already enforces this at route level, but this
 * hook guards components that might be mounted directly (tests, dev tooling, future
 * route changes) and prevents leakage if a route guard ever regresses.
 *
 * Side effect: when the current user is NOT admin/nutricionista, navigate to /dashboard.
 * Does nothing while auth is still loading.
 */
export function useRequireAdmin() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) return;
    if (!user) return; // ProtectedRoute / AdminRoute already handle unauthenticated state
    if (!['admin', 'nutricionista', 'viewer'].includes(user.role)) {
      navigate('/dashboard', { replace: true });
    }
  }, [user, loading, navigate]);
}

export default useRequireAdmin;
